const $inject = ['$rootScope', '$timeout', '$scope', '$routeParams', '$http', 'dataService', 'settingsService', 'lbaLeafletMapService'];

const lbaLatLongMapSearch = function ($rootScope, $timeout, $scope, $routeParams, $http, dataService, settingsService, lbaLeafletMapService) {
  const vm = this;

  const latDataLookUp = dataService.spiltDataAt(vm.settings.latField, $routeParams);
  const longDataLookUp = dataService.spiltDataAt(vm.settings.longField, $routeParams);
  const radiusDataLookUp = dataService.spiltDataAt(vm.settings.radiusField, $routeParams);
  const isImperialSystemDataLookUp= dataService.spiltDataAt(vm.settings.IsImperialSystemField, $routeParams);

  vm.searchForAddress = searchForAddress;
  vm.viewLatLongOnMap = viewLatLongOnMap;
  vm.setLatLong = setLatLong;
  vm.mapLocations = [];
  vm.addressLookUp = '';
  vm.showMap = false;

  $timeout(viewLatLongOnMap, 1000);

  function getLat() {
    return _.get(dataService.data.activeItem, latDataLookUp)
  }

  function getLong() {
    return _.get(dataService.data.activeItem, longDataLookUp)
  }

  function getRadius() {
    return _.get(dataService.data.activeItem, radiusDataLookUp)
  }

  function getIsImperialSystem() {
    return _.get(dataService.data.activeItem, isImperialSystemDataLookUp)
  }

  function viewLatLongOnMap() {
    vm.showMap = true;

    let long = getLong();
    let lat = getLat();
   

    if (long === null || lat === null || long === undefined || lat === undefined) {
      return
    }

    vm.markerOverride = true;

    const radius = getRadius() || 1;
    if (radius) {
      vm.radius = {
        radius: getIsImperialSystem() ? radius * 1609.344 : radius * 1000,
        lat: lat,
        long: long,
        text: `Latitude: ${lat}, Longitude: ${long}`
      };
    }

    refresh();
  }

  function searchForAddress(address) {
    if (!address) {
      return;
    }
    vm.radius = null;
    vm.markerOverride = {text: address, ctaText: 'Set as Lat/Long'};
    lbaLeafletMapService.getPosByAddress(address)
      .then(data => {
        let resources = data.resourceSets[0].resources;
        if (resources.length > 0) {
          vm.mapLocations = [
            {
              Longitude: resources[0].geocodePoints[0].coordinates[1],
              Latitude: resources[0].geocodePoints[0].coordinates[0],
            }
          ];

          refresh();
        }
      });
  }

  function setLatLong() {
    _.set(dataService.data.activeItem, latDataLookUp, vm.mapLocations[0].Latitude);
    _.set(dataService.data.activeItem, longDataLookUp, vm.mapLocations[0].Longitude);
    $rootScope.$broadcast(vm.settings.latField, {refreshData: true});
    $rootScope.$broadcast(vm.settings.longField, {refreshData: true});
    vm.mapLocations = [];
    viewLatLongOnMap();
  }

  function refresh() {
    $timeout(() => {
      $rootScope.$emit('leaflet.refresh', vm.refreshMap);
    });
  }

};

lbaLatLongMapSearch.$inject = $inject;

export default lbaLatLongMapSearch;


// WEBPACK FOOTER //
// ./src/components/lbaLatLongMapSearch/lbaLatLongMapSearchCtrl.js